/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { getComponent } from "cms/components/get-component";
import { isArrayNotEmpty } from "cms/utils/empty-exists";


const ContentZoneDisplay = (props) => {

    const webpage = props?.webpage;
    const value = props?.value;
    const field = props?.field;

    // NOTE: value in a field of component type, is an array of components
    // which also contains `settings`, but we are not using 'field settings' at this time

    return (
        <Fragment>
            {isArrayNotEmpty(value) &&
                value.map((component, index) => {
                    const Component = getComponent(component, field, webpage);

                    const guid = component?.guid;
                    const type = component?.type;
                    const shortType = type.replace("component.","").replace(".","-");
                    const componentId = `field-component-${guid}`;
                    return (
                        <div
                            className={`component ${shortType}`}
                            id={componentId}
                            key={`${componentId}${index}`}
                        >
                            {Component}
                        </div>
                    );
                })
            }
        </Fragment>
    );
};

export { ContentZoneDisplay };
